// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeOWzM2AveCAXnpwHIl6 {
  position: relative;
  width: 90vw;
  margin: auto auto;
  height: 100%;
}
.DeOWzM2AveCAXnpwHIl6 .L8qDJyQ69Y9nvPh7aPBo {
  display: flex;
  flex-direction: column;
  justify-content: start;
  width: 100%;
  height: 100%;
}
.DeOWzM2AveCAXnpwHIl6 .L8qDJyQ69Y9nvPh7aPBo .dD9q3rqMCr_GnT8mYUso {
  display: flex;
  justify-content: center;
  align-items: center;
}
.DeOWzM2AveCAXnpwHIl6 .L8qDJyQ69Y9nvPh7aPBo .dD9q3rqMCr_GnT8mYUso .zdx07C3YgrSgo2MQ6LJA {
  width: 200px;
  height: 48px;
  font-size: 18px !important;
}
.DeOWzM2AveCAXnpwHIl6 .L8qDJyQ69Y9nvPh7aPBo .JLjHEZhlj2CEja9Ulpg3 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
}
.DeOWzM2AveCAXnpwHIl6 .L8qDJyQ69Y9nvPh7aPBo .JLjHEZhlj2CEja9Ulpg3 .MlOR5YAJx4bY7c9REOWj {
  animation: yt9NBlyCHAWAxvDybgBR 2s linear infinite;
}
@keyframes yt9NBlyCHAWAxvDybgBR {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.DeOWzM2AveCAXnpwHIl6 .L8qDJyQ69Y9nvPh7aPBo .VlLIoNRsv0OukpmLWZx8 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  row-gap: 28px;
  height: calc(80vh - 240px);
}
.DeOWzM2AveCAXnpwHIl6 .L8qDJyQ69Y9nvPh7aPBo .VlLIoNRsv0OukpmLWZx8 .XxYzdwvelrcUEDLncFP1 {
  font-size: 24px;
  font-weight: 500;
}
.DeOWzM2AveCAXnpwHIl6 .L8qDJyQ69Y9nvPh7aPBo .VlLIoNRsv0OukpmLWZx8 .f48hZRl2WvInUOjnemfe {
  display: flex;
  column-gap: 24px;
}
.DeOWzM2AveCAXnpwHIl6 .L8qDJyQ69Y9nvPh7aPBo .JLjHEZhlj2CEja9Ulpg3 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
}
.DeOWzM2AveCAXnpwHIl6 .L8qDJyQ69Y9nvPh7aPBo .JLjHEZhlj2CEja9Ulpg3 .MlOR5YAJx4bY7c9REOWj {
  animation: yt9NBlyCHAWAxvDybgBR 2s linear infinite;
}
@keyframes yt9NBlyCHAWAxvDybgBR {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.DeOWzM2AveCAXnpwHIl6 .L8qDJyQ69Y9nvPh7aPBo .dD9q3rqMCr_GnT8mYUso {
  display: flex;
  justify-content: center;
  align-items: center;
}
.DeOWzM2AveCAXnpwHIl6 .L8qDJyQ69Y9nvPh7aPBo .dD9q3rqMCr_GnT8mYUso .zdx07C3YgrSgo2MQ6LJA {
  width: 200px;
  height: 48px;
  font-size: 18px !important;
}
.DeOWzM2AveCAXnpwHIl6 .LjkacRZEdXqqhLukRZFn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  transform: translate(-8px, 12px);
}
.DeOWzM2AveCAXnpwHIl6 .fpWQKHENzSksvddCqSmz {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 32px 0px 0px;
}
.DeOWzM2AveCAXnpwHIl6 .fpWQKHENzSksvddCqSmz .F6x1mu3iIxLYEpHYHgi3 {
  margin: 0px;
}
.DeOWzM2AveCAXnpwHIl6 .fpWQKHENzSksvddCqSmz .f48hZRl2WvInUOjnemfe {
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/modals/ScenesModal/ScenesModal.module.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AAAF;AAEE;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AAAJ;AAEI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAAN;AAEM;EACE,YAAA;EACA,YAAA;EACA,0BAAA;AAAR;AAII;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAFN;AAGM;EACE,kDAAA;AADR;AAIM;EACE;IACE,uBAAA;EAFR;EAIM;IACE,yBAAA;EAFR;AACF;AAMI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,0BAAA;AAJN;AAMM;EACE,eAAA;EACA,gBAAA;AAJR;AAOM;EACE,aAAA;EACA,gBAAA;AALR;AASI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAPN;AAQM;EACE,kDAAA;AANR;AASM;EACE;IACE,uBAAA;EAPR;EASM;IACE,yBAAA;EAPR;AACF;AAWI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AATN;AAWM;EACE,YAAA;EACA,YAAA;EACA,0BAAA;AATR;AAcE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gCAAA;AAZJ;AAeE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;AAbJ;AAeI;EACE,WAAA;AAbN;AAgBI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAdN","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalWrapper": `DeOWzM2AveCAXnpwHIl6`,
	"contentWrapper": `L8qDJyQ69Y9nvPh7aPBo`,
	"loadMore": `dD9q3rqMCr_GnT8mYUso`,
	"button": `zdx07C3YgrSgo2MQ6LJA`,
	"loadingSpinner": `JLjHEZhlj2CEja9Ulpg3`,
	"spinner": `MlOR5YAJx4bY7c9REOWj`,
	"spin": `yt9NBlyCHAWAxvDybgBR`,
	"signInFirst": `VlLIoNRsv0OukpmLWZx8`,
	"title": `XxYzdwvelrcUEDLncFP1`,
	"buttons": `f48hZRl2WvInUOjnemfe`,
	"titleButtons": `LjkacRZEdXqqhLukRZFn`,
	"header": `fpWQKHENzSksvddCqSmz`,
	"tabs": `F6x1mu3iIxLYEpHYHgi3`
};
export default ___CSS_LOADER_EXPORT___;
